// extracted by mini-css-extract-plugin
module.exports = {"page":"page___35lzu","header":"header___3aTHG","logo":"logo___BnbRu","shop":"shop___1QPYv","cover":"cover___1aIHa","wrapper":"wrapper___19EAZ","name":"name___rI-ep","contact":"contact___1H5u-","time":"time___2Uzjv","address":"address___1j2MI","desc":"desc___1ZEgP","back":"back___D2iyj","footer":"footer___1-F6r"};;
    if (module.hot) {
      var injectCss = function injectCss(prev, href) {
        var link = prev.cloneNode();
        link.href = href;
        link.onload = function() {
          prev.parentNode.removeChild(prev);
        };
        prev.stale = true;
        prev.parentNode.insertBefore(link, prev);
      };
      module.hot.dispose(function() {
        window.__webpack_reload_css__ = true;
      });
      if (window.__webpack_reload_css__) {
        module.hot.__webpack_reload_css__ = false;
        console.log("[HMR] Reloading stylesheets...");
        var prefix = document.location.protocol + '//' + document.location.host;
        document
          .querySelectorAll("link[href][rel=stylesheet]")
          .forEach(function(link) {
            if (!link.href.match(prefix) || link.stale) return;
            injectCss(link, link.href.split("?")[0] + "?unix=1792718315015");
          });
      }
    }
  